<template>
  <div class="float-button-container">
    <FloatButton
      href="https://lin.ee/Gh2sAiI"
      target="_blank"
      rel="noopener noreferrer"
    >
      <template #icon
        ><img class="w-[80px]" :src="LineOA" alt="" srcset=""
      /></template>
    </FloatButton>
    <FloatButton href="https://www.beautinq.com/#form">
      <template #icon
        ><img class="w-[80px]" :src="Contact" alt="" srcset=""
      /></template>
    </FloatButton>
  </div>
</template>

<script setup>
import LineOA from '@/assets/float_button/line.webp'
import Contact from '@/assets/float_button/contact.webp'
import FloatButton from '@/components/FloatButton.vue'
</script>

<style scoped lang="postcss">
.float-button-container {
  @apply fixed;
  @apply flex flex-col gap-[8px];
  @apply tablet:( top-[80px] right-[12px]);
  @apply <tablet:(bottom-[12px] right-[8px]);
}
</style>
